import { render } from "./ModalErrorMessages.vue?vue&type=template&id=5dc3fc64&scoped=true"
import script from "./ModalErrorMessages.vue?vue&type=script&lang=js"
export * from "./ModalErrorMessages.vue?vue&type=script&lang=js"

import "./ModalErrorMessages.vue?vue&type=style&index=0&id=5dc3fc64&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dc3fc64"]])

export default __exports__